import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AddStoreResponse, GetStoreResponse, GetStoresResponse, StoreRequest } from '../models/mxp-store.model';

@Injectable({ providedIn: 'root' })
export class MxpStoreService {
  private readonly url = environment.identityUrl.replace(/\/$/, '') + '/api/mxp-stores';

  constructor(private readonly http: HttpClient) {}

  getAllStores(): Observable<GetStoresResponse> {
    return this.http.get<GetStoresResponse>(this.url);
  }

  getStore(id: string): Observable<GetStoreResponse> {
    return this.http.get<GetStoreResponse>(this.url + '/' + encodeURIComponent(id));
  }

  addStore(request: StoreRequest): Observable<AddStoreResponse> {
    return this.http.post<AddStoreResponse>(this.url, request);
  }

  updateStore(id: string, request: StoreRequest): Observable<void> {
    return this.http.put<void>(this.url + '/' + encodeURIComponent(id), request);
  }

  deleteStore(id: string): Observable<void> {
    return this.http.delete<void>(this.url + '/' + encodeURIComponent(id));
  }
}
